@import '../../../globals/main.scss';

pn-chart {
  display: flex;
  height: 100%;
  width: 100%;

  .chart-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;

    width: 100vw;
    height: 30vh;

    padding: 1.6rem 0;

    @media screen and (min-width: $min-width-xxl) {
      padding: 2.4rem 0;
    }
  }

  canvas.pnChart {
    //nytt
    width: 100% !important;
  }

  &[data-chart-type='bar'],
  &[data-chart-type='line'] {
    .chart-wrapper {
      min-height: 100%;
      max-width: 100%;
      min-width: 100%;
    }

    .pnChart {
    }
  }
}

//horizontal card

.fullwidth {
  pn-chart {
    @media screen and (min-width: $min-width-md) {
      justify-content: center;
    }
    .chart-wrapper {
      @media screen and (min-width: $min-width-md) {
        height: 40vh;
        width: 30vw;
      }
    }
  }
}
